import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components//CateringPageComponents/HeroSection";
import ServicesSection from "../components/CateringPageComponents/ServicesSection";
import WhyChooseUsSection from "../components/CateringPageComponents/WhyChooseUsSection";

export default function CateringPage(){
    return(<div>
        <MainLayout>
            <HeroSection/>
            <ServicesSection />
            <WhyChooseUsSection />
        </MainLayout>
    </div>)
    
}